import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Issuef8rh7nn7wz0o as Issue } from './IssueNode.mjs';
import {
  audit21rk6r0re4qdb as audit,
  audit192z89pit0lev as audit_0,
} from './validation.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function assertNotBlank(_this__u8e3s4, summary, description, setOnIssue) {
  summary = summary === VOID ? 'Cannot be blank' : summary;
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return assert(_this__u8e3s4, summary, description, setOnIssue, assertNotBlank$lambda);
}
function assertNotNull(_this__u8e3s4, summary, description, setOnIssue) {
  summary = summary === VOID ? 'Cannot be blank' : summary;
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return assert_0(_this__u8e3s4, summary, description, setOnIssue, assertNotNull$lambda);
}
function assert(_this__u8e3s4, summary, description, setOnIssue, condition) {
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return audit(_this__u8e3s4, (it) => {
    var tmp;
    if (condition(it)) {
      return null;
    }
    return new (Issue())(summary, description, setOnIssue);
  });
}
function assert_0(_this__u8e3s4, summary, description, setOnIssue, condition) {
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return audit_0(_this__u8e3s4, (it) => {
    var tmp;
    if (condition(it)) {
      return null;
    }
    return new (Issue())(summary, description, setOnIssue);
  });
}
function assertNotBlank$lambda(it) {
  // Inline function 'kotlin.text.isNotBlank' call
  return !isBlank(it);
}
function assertNotNull$lambda(it) {
  return !(it == null);
}
//region block: exports
export {
  assertNotBlank as assertNotBlank3rcqh0n27fq5q,
  assertNotNull as assertNotNull1uaw2iegqzgw8,
};
//endregion

//# sourceMappingURL=helpers.mjs.map
